/**
 * Voice Visualization Configuration
 * Allows stakeholders to easily change the visualization style
 * 
 * Options:
 * - 'dynamic-particles': iPhone Style - Dynamic Speed Particles
 */

export type VisualizationStyle = 'dynamic-particles';

export const VOICE_VISUALIZATION_STYLE: VisualizationStyle =
  (import.meta.env.VITE_VOICE_VISUALIZATION_STYLE as VisualizationStyle) || 'dynamic-particles';

